import { GOOGLE_TOS_ACCEPTED } from "constants/storageKeys";

export const setGoogleTosConsent = (isAccepted: boolean): void => {
  try {
    sessionStorage.setItem(GOOGLE_TOS_ACCEPTED, String(isAccepted));
  } catch (error) {
    console.warn("Failed to store terms of service consent:", error);
  }
};
